import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import { DefaultLayoutComponent } from './containers';
import { LogInComponent } from './views/log-in/log-in.component';
import { GlimpseLayoutComponent } from './containers/glimpse-layout/glimpse-layout.component';
import { OAuthComponent } from './views/o-auth/o-auth.component';
import { ResetPasswordSessionComponent } from './password-reset-components/reset-password-session/reset-password-session.component';
import { VerifyOtpComponent } from './password-reset-components/verify-otp/verify-otp.component';
import { ResetOldPasswordComponent } from './password-reset-components/reset-old-password/reset-old-password.component';
import { StoreSelectionComponent } from './views/store-selection/store-selection.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  { path: 'reset-password-session', component: ResetPasswordSessionComponent },
  { path: 'reset-old-password', component: ResetOldPasswordComponent },
  { path: 'verify-otp', component: VerifyOtpComponent },
  {
    path: '',
    component: GlimpseLayoutComponent,
    data: {
      title: 'Home',
    },
    children: [
      // {
      //   path: 'dashboard',
      //   loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule)
      // },

      {
        path: 'footfalls',
        loadChildren: () =>
          import('./views/footfalls/footfalls.module').then(
            (m) => m.FootfallsModule,
          ),
      },
      {
        path: 'heatmaps',
        loadChildren: () =>
          import('./views/heatmaps/heatmaps.module').then(
            (m) => m.HeatmapsModule,
          ),
      },
      {
        path: 'mhe-heatmap',
        loadChildren: () =>
          import('./views/mhe-heatmap/mhe-heatmap.module').then(
            (m) => m.MheHeatmapModule,
          ),
      },
      {
        path: 'demographics',
        loadChildren: () =>
          import('./views/demographics/demographics.module').then(
            (m) => m.DemographicsModule,
          ),
      },
      // {
      //   path: 'export-data',
      //   loadChildren: () => import('./views/export-data/export-data.module').then(m => m.ExportDataModule)
      // },
      // {
      //   path: 'store-paths',
      //   loadChildren: () => import('./views/storePaths/store-paths/store-paths.module').then(m => m.StorePathsModule)
      // },
      // {
      //   path: 'dwell-time',
      //   loadChildren: () => import('./views/dwell-time/dwell-time.module').then(m => m.DwellTimeModule)
      // },
      // {
      //   path: 'category-performance',
      //   loadChildren: () => import('./views/cat-performance/cat-performance.module').then(m => m.CatPerformanceModule)
      // // },
      {
        path: 'conversion',
        loadChildren: () =>
          import('./views/conversions/conversions.module').then(
            (m) => m.ConversionsModule,
          ),
      },
      {
        path: 'passer-by',
        loadChildren: () =>
          import('./views/passer-by/passer-by.module').then(
            (m) => m.PasserByModule,
          ),
      },
      {
        path: 'virtual-demarkation-occupancy',
        loadChildren: () =>
          import('./views/ppe-occupancy/ppe-occupancy-module').then(
            (m) => m.PpeOccupancyModule,
          ),
      },
      {
        path: 'ppe-occupancy',
        loadChildren: () =>
          import('./views/ppe-occupancy/ppe-occupancy-module').then(
            (m) => m.PpeOccupancyModule,
          ),
      },
      {
        path: 'p&g-boundary',
        loadChildren: () =>
          import('./views/ppe-occupancy/ppe-occupancy-module').then(
            (m) => m.PpeOccupancyModule,
          ),
      },
      // {
      //   path: 'shopper-profiles',
      //   loadChildren: () => import('./views/shopper-profile/shopper-profile.module').then(m => m.ShopperProfileModule )
      // },
      // {
      //   path: 'shopper-trends',
      //   loadChildren: () => import('./views/shopper-trends/shopper-trends.module').then(m => m.ShopperTrendsModule )
      // },
      // {
      //   path: 'triggers',
      //   loadChildren: () => import('./views/triggers/triggers.module').then(m => m.TriggersModule )
      // },
      // {
      //   path: 'category-view',
      //   loadChildren: () => import('./views/category-view/category-view.module').then(m => m.CategoryViewModule )
      // },

      {
        path: 'sd',
        loadChildren: () =>
          import('./views/social-distance/social-distance.module').then(
            (m) => m.SocialDistanceModule,
          ),
      },
      {
        path: 'mhe-collision',
        loadChildren: () =>
          import('./views/mhe-collision/mhe-collision.module').then(
            (m) => m.MheCollisionModule,
          ),
      },
      {
        path: 'mobile-violation',
        loadChildren: () =>
          import('./views/mobile-violation/mobile-violation.module').then(
            (m) => m.MobileViolationModule,
          ),
      },
      {
        path: 'handrail-violation',
        loadChildren: () =>
          import('./views/handrail-violation/handrail-violation.module').then(
            (m) => m.HandrailViolationModule,
          ),
      },
      {
        path: 'md',
        loadChildren: () =>
          import('./views/mask-detection/mask-detection.module').then(
            (m) => m.MaskDetectionModule,
          ),
      },
      {
        path: 'lo',
        loadChildren: () =>
          import('./views/live-occupancy/live-occupancy.module').then(
            (m) => m.LiveOccupancyModule,
          ),
      },
      {
        path: 'sanitation',
        loadChildren: () =>
          import('./views/sanitation/sanitation.module').then(
            (m) => m.SanitationModule,
          ),
      },
      {
        path: 'members',
        loadChildren: () =>
          import('./views/members/members.module').then((m) => m.MembersModule),
      },
      {
        path: 'compare',
        loadChildren: () =>
          import('./views/compare/compare.module').then((m) => m.CompareModule),
      },
      {
        path: 'queue-length',
        loadChildren: () =>
          import('./views/queue-lengths/queue-lengths.module').then(
            (m) => m.QueueLengthsModule,
          ),
      },
      {
        path: 'explore-graphs',
        loadChildren: () =>
          import('./views/explore-times/explore-times.module').then(
            (m) => m.ExploreTimesModule,
          ),
      },
      {
        path: 'gate-date',
        loadChildren: () =>
          import('./views/gate-data/gate-data.module').then(
            (m) => m.GateDataModule,
          ),
      },
      {
        path: 'report-section',
        loadChildren: () =>
          import('./views/report-section/report-section.module').then(
            (m) => m.ReportSectionModule,
          ),
      },
      {
        path: 'report-data',
        loadChildren: () =>
          import('./views/report-data/report-data.module').then(
            (m) => m.ReportDataModule,
          ),
      },
      {
        path: 'vehicle-analysis',
        loadChildren: () =>
          import('./views/vehicle-analysis/vehicle-analysis.module').then(
            (m) => m.VehicleAnalysisModule,
          ),
      },
      {
        path: 'support',
        loadChildren: () =>
          import('./views/support/support.module').then((m) => m.SupportModule),
      },
      {
        path: 'gate-analysis',
        loadChildren: () =>
          import('./views/gate-analysis/gate-analysis.module').then(
            (m) => m.GateAnalysisModule,
          ),
      },
      {
        path: 'camera-status',
        loadChildren: () =>
          import('./views/camera-status/camera-status.module').then(
            (m) => m.CameraStatusModule,
          ),
      },
      {
        path: 'costa-queue-analysis',
        loadChildren: () =>
          import(
            './views/costa-queue-analysis/costa-queue-analysis.module'
          ).then((m) => m.CostaQueueAnalysisModule),
      },
      {
        path: 'staff-interaction',
        loadChildren: () =>
          import('./views/staff-interaction/staff-interaction.module').then(
            (m) => m.StaffInteractionModule,
          ),
      },
      {
        path: 'queue-analysis',
        loadChildren: () =>
          import('./views/queue-analysis/queue-analysis.module').then(
            (m) => m.QueueAnalysisModule,
          ),
      },
      {
        path: 'engagement_times_alert',
        loadChildren: () =>
          import('./views/queue-analysis/queue-analysis.module').then(
            (m) => m.QueueAnalysisModule,
          ),
      },
      {
        path: 'maintenance',
        loadChildren: () =>
          import('./views/maintanance/maintanance.module').then(
            (m) => m.MaintanaceModule,
          ),
      },
      {
        path: 'user-access',
        loadChildren: () =>
          import(
            './views/user-access-management/user-access-management.module'
          ).then((m) => m.UserAccessManagementModule),
      },
      {
        path: 'vegetation',
        loadChildren: () =>
          import('./views/vegetation/vegetation.module').then(
            (m) => m.VegetationModule,
          ),
      },
      {
        path: 'lighting',
        loadChildren: () =>
          import('./views/vegetation/vegetation.module').then(
            (m) => m.VegetationModule,
          ),
      },
      {
        path: 'rail_head',
        loadChildren: () =>
          import('./views/vegetation/vegetation.module').then(
            (m) => m.VegetationModule,
          ),
      },
      {
        path: 'signaling',
        loadChildren: () =>
          import('./views/vegetation/vegetation.module').then(
            (m) => m.VegetationModule,
          ),
      },
      {
        path: 'data-fill',
        loadChildren: () =>
          import('./views/data-fill/data-fill.module').then(
            (m) => m.DataFillModule,
          ),
      },
      {
        path: 'client-onboarding',
        loadChildren: () =>
          import('./views/store-list/store-list.module').then(
            (m) => m.StoreListModule,
          ),
      },
      {
        path: 'camera-list',
        loadChildren: () =>
          import('./views/camera-list/camera-list.module').then(
            (m) => m.CameraListModule,
          ),
      },
      {
        path: 'accuracy-report',
        loadChildren: () =>
          import('./views/accuracy-report/accuracy-report.module').then(
            (m) => m.AccuracyReportModule,
          ),
      },
      {
        path: 'accuracy-details',
        loadChildren: () =>
          import('./views/accuracy-details/accuracy-details.module').then(
            (m) => m.AccuracyDetailsModule,
          ),
      },
    ],
  },
  { path: 'login', component: LogInComponent },
  { path: 'store-selection', component: StoreSelectionComponent },
  { path: 'oauthredirect', component: OAuthComponent },
  { path: '**', component: GlimpseLayoutComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
